import {Directive, ElementRef, OnInit, inject} from '@angular/core';
import {SocialAuthService} from '@abacritt/angularx-social-login';
import {take} from 'rxjs/operators';

declare var google;

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: 'google-signin-button',
})
export class GoogleSigninButtonDirective implements OnInit {
  private el = inject(ElementRef);
  private socialAuthService = inject(SocialAuthService);


  ngOnInit() {
    this.socialAuthService.initState.pipe(take(1)).subscribe(() => {
      google.accounts.id.renderButton(this.el.nativeElement, {
        type: 'standard',
        size: 'medium',
        text: 'signin_with',
        theme: 'outline',
        width: 200
      });
    });
  }
}
